<script setup lang="ts">
  import { MpCard, MpText } from '@borg/ui';

  const projectConfig = useProjectConfig();
</script>

<template>
  <MpCard
    v-if="projectConfig.features.myPaycheck.enabled"
    shadow
    border
    class="container no-print"
  >
    <div>
      <MpText
        as="h3"
        style="margin-bottom: 4px"
      >
        {{ $t('MY_PAYCHECK.TITLE') }}
      </MpText>
      <MpText
        no-margin
        type="h5"
        :bold="false"
        semibold
      >
        {{ $t('MY_PAYCHECK.SUBTITLE') }}
      </MpText>
    </div>
    <a
      class="container__button-outer"
      :href="projectConfig.features.myPaycheck.buttonUrl"
      target="_blank"
    >
      <div class="container__button-inner">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M13 9L16 12M16 12L13 15M16 12H8M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#303335"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="container__button-text">
          {{ $t('MY_PAYCHECK.BUTTON') }}
        </div>
      </div>
    </a>
    <a
      :href="projectConfig.features.myPaycheck.baseUrl"
      target="_blank"
    >
      <Illustration
        image="my-paycheck"
        height="25"
      />
    </a>
  </MpCard>
</template>

<style scoped lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: var(--mp-space-60);

    &__button-outer {
      display: flex;
      height: 40px;
      padding: var(--mp-space-20, 4px) var(--mp-space-50, 16px) var(--mp-space-20, 4px) 13px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: var(--mp-space-30, 8px);
      border-radius: var(--mp-radius-30, 10px);
      background: #a5da6a;
      text-decoration: none;
    }

    &__button-inner {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    &__button-text {
      color: var(--mp-color-grey-black, #1d1d1f);
      text-align: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
</style>
